// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import LoadingBar from './view'

export default function LoadingBarFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/LoadingBar">
      <LoadingBar {...props}>
        {children}
      </LoadingBar>
    </Flow>
  )
}
